import { Button, Icon, Tooltip } from '@dixa/lib-shared-habla';
import { useHasAccess } from 'lib-shared-access-control';
import { shallowEqual } from 'react-redux';

import { getLatestFacebookConversation } from 'components/conversation/selectors';
import { canConversationTransferToQueue } from 'components/conversation/utils/conversationTransfer';
import { useAppSelector } from 'utils/redux/useAppSelector';

import { TransferToQueueDropdown } from './components/transferToQueueDropdown/transferToQueueDropdown';
import styles from './conversationTransferToQueue.module.scss';

export const ConversationTransferToQueue = (): JSX.Element => {
  const [
    metaConversation,
    conversationAsyncStatus,
    latestMessengerConversation,
  ] = useAppSelector(
    (state) => [
      state.conversation.metaConversation,
      state.conversation.asyncStatus.getConversation,
      getLatestFacebookConversation(state),
    ],
    shallowEqual,
  );
  const hasReplyAccess = useHasAccess('conversation.reply');

  const disabledButton = (
    <Button
      variant="tertiary"
      disabled
      isLoading={conversationAsyncStatus === 'loading'}
      slotStart={<Icon name="flow" />}
      className={styles.button}
    >
      {metaConversation.conversation.queue?.name || `Not in queue`}
    </Button>
  );

  if (!hasReplyAccess) {
    return (
      <Tooltip content="You don't have permissions to transfer to queue">
        {disabledButton}
      </Tooltip>
    );
  }

  const canTransferToQueue = canConversationTransferToQueue(
    metaConversation,
    latestMessengerConversation,
  );

  return canTransferToQueue ? <TransferToQueueDropdown /> : disabledButton;
};
